export class LoanAppraisalSurchargesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getLoanAppraisalSurcharges({ loanId, applicationId }) {
    return this.#http.get(`/api/loans/${loanId}/appraisal-surcharges`, {
      params: { applicationId },
    });
  }
}
